import React from 'react';

import {
  AssetIcon,
  BankIcon,
  BuildingIcon,
  DollarIcon,
  WalletIcon,
} from '@sharedCR/coreDesignSystem/icons';

import { formatMoney } from '../../Construction.utils';

export const getSummaryStatsConfig = ({ totals, budget }) => [
  {
    id: 'totalBudget',
    title: 'Total Budget',
    value: formatMoney(budget?.totalBudget ?? totals.budgeted),
    icon: <WalletIcon />,
  },
  {
    id: 'fundedToDate',
    title: 'Funded to Date',
    value: formatMoney(budget?.fundedToDate ?? totals.fundedToDate),
    icon: <DollarIcon />,
  },
  {
    id: 'remaining',
    title: 'Remaining',
    value: formatMoney(budget?.remaining ?? totals.remaining),
    icon: <BankIcon />,
  },
  {
    id: 'retainageHeld',
    title: 'Retainage Held',
    value: formatMoney(budget?.retainageHeld),
    icon: <AssetIcon />,
  },
  {
    id: 'contingency',
    title: 'Contingency',
    value: formatMoney(budget?.contingencyRemaining),
    icon: <BuildingIcon />,
  },
];
